import {
  getFormValue,
  setSectionLabel,
} from 'app/services/businessFunctionHelpers';
import {
  FieldsEnum,
  FormsEnum,
  LabelEnum,
  SectionsEnum,
} from 'app/shared/enums';

const formName = FormsEnum.CheckoutForm;

const nameAndLastnameChange = {
  updateOwnerLabel() {
    const name = getFormValue(FieldsEnum.CheckoutOwnerName, formName) || '';
    const lastName =
      getFormValue(FieldsEnum.CheckoutOwnerLastName, formName) || '';

    setSectionLabel({
      key: SectionsEnum.CheckoutSectionInsurant4Owner,
      formName: FormsEnum.CheckoutForm,
      label: `${LabelEnum.Owner} - ${name} ${lastName}`,
    });
  },
};

export default nameAndLastnameChange;
